import React, { useMemo, useState } from 'react';
import PatientDetailSegmentNav from './subparts/PatientDetailSegmentNav';
import Overview from './tabs/Overview';
import PatientAppointments from './tabs/PatientAppointments';
import PatientCommunicationPreferenceCard from './tabs/PatientCommunicationPreferenceCard';
import PatientInvalidDetails from './tabs/PatientInvalidData';
import PatientActivity from './tabs/PatientActivity';

function PatientTabs({ patient, onPatientUpdated, onCommPrefsUpdated }) {
    const [activeTab, setActiveTab] = useState('overview');

    const tabs = useMemo(
        () => [
            {
                id: 'overview',
                label: 'Patient Info',
                icon: 'bi-person-vcard',
                content: <Overview patient={patient} onPatientUpdated={onPatientUpdated} />,
            },
            {
                id: 'appointments',
                label: 'Appointments',
                icon: 'bi-calendar-check',
                content: <PatientAppointments patient={patient} />,
            },
            {
                id: 'comm-pref',
                label: 'Communication',
                icon: 'bi-chat-square-text',
                content: (
                    <PatientCommunicationPreferenceCard
                        patient={patient}
                        onCommPrefsUpdated={onCommPrefsUpdated}
                    />
                ),
            },
            {
                id: 'activity',
                label: 'Activity',
                icon: 'bi-activity',
                content: <PatientActivity patientId={patient.id} />,
            },
            {
                id: 'invalid-info',
                label: 'Invalid Info',
                icon: 'bi-exclamation-triangle',
                content: <PatientInvalidDetails patient={patient} />,
            },
        ],
        [patient, onPatientUpdated, onCommPrefsUpdated]
    );

    const activeContent = tabs.find((tab) => tab.id === activeTab)?.content;

    return (
        <div className="patient-detail-tabs">
            <div className="patient-detail-tabs__nav-wrap">
                <PatientDetailSegmentNav
                    tabs={tabs}
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                />
            </div>

            <div className="patient-detail-tabs__content">{activeContent}</div>
        </div>
    );
}

export default PatientTabs;
